import React from "react";

export default function Fab({ onClick, icon: Icon, label, className = "", ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      {...props}
      className={
        // no fixed/bottom/right here; FabStack controls positioning
        `relative inline-flex items-center gap-2
         rounded-full px-4 py-3 shadow-lg border bg-white
         hover:shadow-xl focus:outline-none ${className}`
      }
    >
      {Icon ? <Icon className="h-5 w-5" /> : null}
      <span className="font-medium">{label}</span>
    </button>
  );
}
